class Opal_Give {
    constructor() {
        $(document).on('click', '[data-toogle="worldlife-video"]', (event) => {
            this.video(event);
        })
        $(document).on('click', '[data-toogle="worldlife-gallery"]', (event) => {
            this.gallery(event);
        })
        this.gallery_single();
        this.single_tabs();
    }

    video(event) {
        event.preventDefault();
        let $button = $(event.currentTarget);
        if ($button.data('loaded')) {
            $button.find('.ajax-worldlife-video a').trigger('click');
        } else {
            $.ajax({
                method    : 'POST',
                url       : worldlife.ajaxurl,
                data      : {
                    action : 'get_worldlife_video',
                    give_id: $button.data('worldlife-id'),
                },
                beforeSend: () => {
                    $button.addClass('loading');
                },
                success   : (response) => {
                    $button.data('loaded', true);
                    if (response) {
                        $button.append(this.renderVideoHTML(response));
                        let $video = $button.find('.ajax-worldlife-video a');
                        $video.magnificPopup({
                            disableOn      : 700,
                            type           : 'iframe',
                            mainClass      : 'mfp-fade',
                            removalDelay   : 160,
                            preloader      : false,
                            fixedContentPos: false
                        });
                        $video.trigger('click');
                    }
                    $button.removeClass('loading');
                }
            })
        }
    }

    gallery(event) {
        event.preventDefault();
        let $button = $(event.currentTarget);
        if ($button.data('loaded')) {
            $button.find('.ajax-worldlife-gallery a:first-child').trigger('click');
        } else {
            $.ajax({
                method    : 'POST',
                url       : worldlife.ajaxurl,
                data      : {
                    action : 'get_worldlife_gallery',
                    give_id: $button.data('worldlife-id'),
                },
                beforeSend: () => {
                    $button.addClass('loading');
                },
                success   : (response) => {
                    $button.data('loaded', true);
                    if (response) {
                        $button.append(this.renderGalleryHTML(response));
                        let $gallery = $button.find('.ajax-worldlife-gallery');
                        $gallery.magnificPopup({
                            delegate: 'a', // the selector for gallery item
                            type    : 'image',
                            gallery : {
                                enabled: true
                            }
                        });
                        $gallery.find('>a:first-child').trigger('click');
                    }
                    $button.removeClass('loading');
                }
            })
        }
    }

    renderVideoHTML(video) {
        return `<div class="ajax-worldlife-video"><a href="${video}"></a></div>`;
    }

    renderGalleryHTML(listImages) {
        let html = `<div class="ajax-worldlife-gallery">`
        for (let i in listImages) {
            html += `<a href="${listImages[i]}"><img src="${listImages[i]}"></a>`;
        }
        html += '</div>';
        return html;
    }

    gallery_single() {
        $('.single-give_forms .gallery').magnificPopup({
            delegate : 'a',
            type     : 'image',
            tLoading : 'Loading image #%curr%...',
            mainClass: 'mfp-img-mobile',
            gallery  : {
                enabled           : true,
                navigateByImgClick: true,
                preload           : [0, 1]
            },
            image    : {
                tError  : '<a href="%url%">The image #%curr%</a> could not be loaded.',
                titleSrc: function (item) {
                    return item.el.attr('title');
                }
            }
        });
    }

    single_tabs() {
        let $tabs = $("#give-form-single-tab");
        if ($tabs.length > 0) {
            $tabs.tabs();
        }
    }
}

$(document).ready(function () {
    new Opal_Give();
});